export async function fetchOrganizationEvents(tenantId: string): Promise<any[]> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/events/organization/${tenantId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch events: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
}